import * as React from 'react';
import {List} from './List';
import s from './navigation.scss';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {RouteComponentProps} from 'react-router';
import {productsSelector, additionalProductsSelector} from '../../selectors/navigation';
import {Route} from '../../routes/navigation';
import {WithTranslation, withTranslation} from 'react-i18next';
import SearchBox from '../../containers/SearchBox';
import {Experiment} from '../../reducers/experiments';
import CurrentLocation from '../partials/CurrentLocation';
import classnames from 'classnames';
import {NavLink} from 'react-router-dom';
import {allUpdates} from '../../routes/navigation';

export interface TopNavigationProps extends RouteComponentProps<{}>, WithTranslation {
  products: Route[];
  additionalProducts: Route[];
  allProducts: Route[];
  label?: string;
  searchTerms?: string;
  experiments?: Experiment[];
}

export class TopNavigationCmp extends React.PureComponent<TopNavigationProps> {
  render() {
    const props = this.props;
    const navClass = classnames({
      [s.topNav]: true,
      [s.searchResults]: props.searchTerms,
    });
    return <aside className={navClass}>
      <List itemHooks="product-link" history={props.history} items={props.products}/>
      <div className={s.dropdownWrap}>
        <span data-hooks="active-category" className={s.activeCategoryLabel}>{props.t(props.label)}</span>
        <NavLink data-hooks="label" className={s.more} to="/">{props.t('navigation.more')}</NavLink>
        <List
          itemClassName={s.nestedLink}
          className={s.additionalProducts}
          itemHooks="extra-product-link"
          history={props.history}
          items={props.allProducts}
          behaviour="dropdown"
        />
      </div>
      <div className={s.searchMobileNav}>
        <NavLink className={s.searchBackLink} to={allUpdates.path}/>
        <CurrentLocation
          className={s.currentLocation}
          label={props.label}
          experiments={props.experiments}
          searchTerms={props.searchTerms}
        />
      </div>
      <SearchBox history={props.history} mobile={false} search={props.searchTerms}/>
    </aside>;
  }
}

function mapStateToProps(state) {
  const products = productsSelector(state);
  const additionalProducts = additionalProductsSelector(state);

  return {
    products,
    additionalProducts,
    allProducts: products.concat(additionalProducts)
  };
}

export const TopNavigation: any = withRouter(withTranslation()(connect(mapStateToProps, null)(TopNavigationCmp)) as React.ComponentType<any>);
